// Shared Cart Management Utility
export const CartManager = {

  getGuestSessionId: () => {
    let guestId = localStorage.getItem('swapify_guest_id');
    if (!guestId) {
      guestId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('swapify_guest_id', guestId);
    }

    return guestId;
  },

  getCart: () => {
    const cart = localStorage.getItem('swapify_cart');
    return cart ? JSON.parse(cart) : { items: [], expiresAt: null };
  },
  
  setCart: (cartData) => {
    localStorage.setItem('swapify_cart', JSON.stringify(cartData));
  },
  
  addToCart: (giftCard) => {
    const cart = CartManager.getCart();
    
    // Add the specific card as individual item
    const cartItem = {
      ...giftCard,
      cartId: `${giftCard.id}_${Date.now()}`, // Unique cart ID
      addedAt: new Date().toISOString()
    };
    
    cart.items.push(cartItem);
    
    // Reset timer for entire cart when new item added
    cart.expiresAt = new Date(Date.now() + 10 * 60 * 1000).toISOString(); // 10 minutes from now
    
    CartManager.setCart(cart);
    
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
    
    return cart;
  },
  
  removeFromCart: (cartId) => {
    const cart = CartManager.getCart();
    cart.items = cart.items.filter(item => item.cartId !== cartId);
    
    // If cart is empty, clear expiration
    if (cart.items.length === 0) {
      cart.expiresAt = null;
    }
    
    CartManager.setCart(cart);
    
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
    
    return cart;
  },
  
  clearCart: () => {
    localStorage.removeItem('swapify_cart');
    
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { items: [], expiresAt: null } }));
  },
  
  isCartExpired: (expiresAt) => {
    if (!expiresAt) return false;
    return new Date() > new Date(expiresAt);
  },
  
  cleanExpiredCart: () => {
    const cart = CartManager.getCart();
    
    if (cart.expiresAt && CartManager.isCartExpired(cart.expiresAt)) {
      // Clear entire cart if expired
      CartManager.clearCart();
      return { items: [], expiresAt: null };
    }
    
    return cart;
  },
  
  isItemInCart: (giftCardId) => {
    const cart = CartManager.getCart();
    return cart.items.some(item => item.id === giftCardId);
  },
  
  getCartItemCount: () => {
    const cart = CartManager.getCart();
    return cart.items.length;
  }
};
